.card {
  &--wrapper {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    border: 1px solid;
    border-color: var(--chart-103-pressed);
    background-color: var(--white-layout-302-level-1-elevation);
    color: var(--body-text-arrows-400);
    position: relative;
    justify-content: center;
  }

  &--content {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }

  &--title-wrap {
    display: flex;
    align-items: center;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(8 * var(--spacer));
      height: calc(8 * var(--spacer));
      border: 1px solid var(--chart-100-pressed);
      border-radius: 50%;
      flex-shrink: 0;
      margin-right: calc(3 * var(--spacer));
    }
  }

  &--title {
    line-height: 28px;
    color: var(--body-text-arrows-400);
  }

  &--action-button-wrapper {
    margin-top: auto;
  }

  &--action-button {
    margin-top: calc(3 * var(--spacer));
  }
}
